<section class="detailed-booking">
  <ng-container *ngFor="let e of li">
    <div class="container" *ngIf="e.t_id == pageid">
      <header class="trip-hero">
        <div class="trip-hero__heading">
          <p class="eyebrow">Route details</p>
          <h1>Trip {{ e.t_in_id }}</h1>
          <div class="route-line" aria-label="Trip route">
            <div class="route-stop route-stop--from">
              <span class="route-dot"></span>
              <div>
                <small>Pickup</small>
                <strong>{{ e.t_trip_fromlocation }}</strong>
              </div>
            </div>
            <div class="route-connector"></div>
            <div class="route-stop route-stop--to">
              <span class="route-dot"></span>
              <div>
                <small>Drop-off</small>
                <strong>{{ e.t_trip_tolocation }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="trip-status" aria-label="Trip status">
          <span class="status-label">Status</span>
          <span class="status-pill status-pill--ongoing" *ngIf="e.t_trip_status == 'OnGoing'">Ongoing</span>
          <span class="status-pill status-pill--completed" *ngIf="e.t_trip_status == 'completed'">Completed</span>
          <span class="status-pill status-pill--upcoming" *ngIf="e.t_trip_status == 'yettostart'">Yet to start</span>
          <span class="status-pill status-pill--cancelled" *ngIf="e.t_trip_status == 'cancelled'">Cancelled</span>
          <span class="status-pill status-pill--pending" *ngIf="e.t_trip_status == 'yettoconfirm'">Yet to confirm</span>
        </div>
      </header>

      <div class="summary-grid">
        <div class="summary-item">
          <mat-icon>event</mat-icon>
          <div>
            <small>Pickup date</small>
            <strong>{{ e.t_start_date | date:'MMM d, y' }}</strong>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon>schedule</mat-icon>
          <div>
            <small>Pickup time</small>
            <strong>{{ formatTime(e.t_start_time) }}</strong>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon>groups</mat-icon>
          <div>
            <small>Passengers</small>
            <strong>{{ e.t_passengers || 'Not specified' }}</strong>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon>directions_car</mat-icon>
          <div>
            <small>Vehicle</small>
            <strong>{{ e.t_vechicle === 'suv' || e.t_vechicle === 'sedan' ? 'SUV / Sedan' : (e.t_vechicle || 'Not selected') }}</strong>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon>local_shipping</mat-icon>
          <div>
            <small>Trailer towing</small>
            <strong>{{ e.trailer_towing == 1 ? 'Required' : 'Not required' }}</strong>
          </div>
        </div>
        <div class="summary-item summary-item--total">
          <mat-icon>receipt_long</mat-icon>
          <div>
            <small>Total charge</small>
            <strong>${{ e.t_trip_amount || 0 }}</strong>
          </div>
        </div>
      </div>

      <div class="content-grid">
        <main class="content-main">
          <section class="detail-card">
            <div class="card-heading">
              <div>
                <p class="eyebrow">Overview</p>
                <h2>Booking information</h2>
              </div>
              <span class="booking-type">{{ e.t_booking_type || 'Standard' }}</span>
            </div>

            <div class="detail-list">
              <div class="detail-row">
                <span>Trip ID</span>
                <strong>{{ e.t_in_id }}</strong>
              </div>
              <div class="detail-row">
                <span>Booked on</span>
                <strong>{{ e.t_created_date | date:'MMM d, y' }}</strong>
              </div>
              <div class="detail-row">
                <span>Trip type</span>
                <strong>{{ e.t_type == 'outstation' ? 'Long distance' : e.t_type }}</strong>
              </div>
              <div class="detail-row" *ngIf="e.t_type == 'outstation'">
                <span>Return date</span>
                <strong>{{ e.t_end_date | date:'MMM d, y' }}</strong>
              </div>
              <div class="detail-row">
                <span>Preferred driver</span>
                <strong>{{ e.t_prefer_driver?.split('/')?.pop() || 'No preference' }}</strong>
              </div>
              <div class="detail-row detail-row--wide">
                <span>Intermediate stops</span>
                <strong>{{ e.t_intermediate_stops ? checkstops(e.t_intermediate_stops) : 'None' }}</strong>
                <input class="d-none" id="temp" value="{{ e.t_intermediate_stops }}">
              </div>
              <div class="detail-row detail-row--wide">
                <span>Booking comment</span>
                <strong>{{ e.t_comment || 'No comment added' }}</strong>
              </div>
            </div>
          </section>

          <section class="detail-card charges-card">
            <div class="card-heading">
              <div>
                <p class="eyebrow">Payment</p>
                <h2>Charge summary</h2>
              </div>
            </div>
            <div class="charge-row">
              <span>Additional charge</span>
              <strong>${{ e.t_additional_charge || 0 }}</strong>
            </div>
            <div class="charge-row">
              <span>Driver tip</span>
              <strong>${{ e.t_tip || 0 }}</strong>
            </div>
            <div class="charge-row charge-row--total">
              <span>Total charge</span>
              <strong>${{ e.t_trip_amount || 0 }}</strong>
            </div>
          </section>
        </main>

        <aside class="content-side">
          <a mat-button class="action-button action-button--primary" routerLink="/invoice">
            <mat-icon>picture_as_pdf</mat-icon>
            Download invoice
          </a>

          <section class="side-card driver-card" *ngIf="e.t_driver != ''; else noDriver">
            <div class="side-card__icon"><mat-icon>person</mat-icon></div>
            <p class="eyebrow">Your driver</p>
            <a *ngIf="e.driver_profile_url; else driverNameOnly"
               class="driver-profile-link"
               [href]="e.driver_profile_url"
               target="_blank"
               rel="noopener">
              <h2>{{ e.t_driver_name }}</h2>
              <span>View driver profile <mat-icon>open_in_new</mat-icon></span>
            </a>
            <ng-template #driverNameOnly>
              <h2>{{ e.t_driver_name }}</h2>
            </ng-template>
            <p class="muted">Vehicle ID {{ e.t_driver }}</p>

            <div class="cancel-panel" *ngIf="isShown2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Reason for cancellation</mat-label>
                <textarea matInput #driverReason required></textarea>
              </mat-form-field>
              <button mat-button class="action-button action-button--danger" (click)="cancelBooking(driverReason.value,e.t_id,'driver',e.t_driver)">Submit request</button>
            </div>
            <button mat-button class="text-action" id="cancel2" *ngIf="e.t_trip_status == 'yettostart'" (click)="toggleShow2()">Cancel driver</button>
          </section>

          <ng-template #noDriver>
            <section class="side-card empty-driver">
              <div class="side-card__icon"><mat-icon>person_off</mat-icon></div>
              <p class="eyebrow">Your driver</p>
              <h2>Not assigned yet</h2>
              <p class="muted">We’ll update this trip as soon as a driver is confirmed.</p>
            </section>
          </ng-template>

          <section class="side-card help-card">
            <div class="side-card__icon"><mat-icon>support_agent</mat-icon></div>
            <p class="eyebrow">Need help?</p>
            <h2>We’re happy to assist</h2>
            <a href="tel:330-474-9507" class="phone-link">
              <mat-icon>phone</mat-icon>
              330-474-9507
            </a>
          </section>

          <div class="cancel-panel side-card" id="reasonbox" *ngIf="isShown">
            <h2>Cancel this booking</h2>
            <p class="muted">Tell us why you need to cancel.</p>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Reason for cancellation</mat-label>
              <textarea matInput #bookingReason required></textarea>
            </mat-form-field>
            <button mat-button class="action-button action-button--danger" (click)="cancelBooking(bookingReason.value,e.t_id,'booking',e.t_driver)">Submit cancellation</button>
          </div>

          <button mat-button class="text-action text-action--danger" id="cancel" *ngIf="e.t_trip_status == 'yettostart'" (click)="toggleShow()">Cancel booking</button>
        </aside>
      </div>
    </div>
  </ng-container>
</section>
